import React from 'react';

interface ArrowRightIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	stroke?: string;
}

export function ArrowRightIcon({
	width = 24,
	height = 24,
	stroke = 'currentColor',
	...props
}: Readonly<ArrowRightIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.51013 12.2126C3.51133 12.122 3.58938 12.0452 3.67992 12.0454L15.9419 12.0735C16.3541 12.0743 16.7262 11.827 16.8859 11.4469C17.0455 11.0669 16.9612 10.6286 16.6722 10.3348L11.5657 5.14852C11.5153 5.09702 11.5057 4.99786 11.5771 4.92763C11.6484 4.85754 11.7467 4.8692 11.7974 4.92036L18.8881 12.1219C18.9387 12.1733 18.9488 12.2717 18.8774 12.3421L11.5617 19.5452C11.4903 19.6156 11.3913 19.6045 11.3407 19.5531C11.29 19.5014 11.281 19.4022 11.3521 19.3322L16.6296 14.136C16.9249 13.8453 17.0159 13.4041 16.8592 13.0205C16.7025 12.6369 16.3289 12.3864 15.9146 12.3854L3.65264 12.3573C3.57106 12.357 3.50932 12.294 3.51013 12.2126Z"
				stroke={stroke}
				strokeWidth={2.04419}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
